import { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { Flex } from '@qga/roo-ui/components';

import useMobileRoomScrollIntoView from '@shared/v2/hooks/useMobileRoomScrollIntoView';

import RoomOption from '@/v2/components/pages/PackageViewV2/components/RoomOptions/components/RoomOption';
import { useRoomOptionsData } from '@/v2/components/pages/PackageViewV2/contexts/RoomOptionsContext';
import { usePackagePageV3 } from '@/v2/hooks/featureFlags/packagePageV3/usePackagePageV3';
import { UI } from '@/v2/types';
import { useSearchPanelControls } from '../../../../contexts/SearchPanelContext';

export type RoomListProps = Omit<ComponentProps<typeof Flex>, 'roomOptions'> & {
  roomOptions: UI.RoomOption[] | undefined | null;
  roomIndexOffset?: number;
  isMainRooms?: boolean;
};

const RoomListContainer = styled(Flex)`
  gap: 16px;
`;

const RoomList = ({
  roomOptions,
  roomIndexOffset,
  onCtaClick: onCtaClickOverride,
  isMainRooms,
  ...rest
}: RoomListProps) => {
  const isPackagePageV3Enabled = usePackagePageV3();
  const {
    isLoading,
    selectedRoomOption,
    onCtaClick = () => {},
  } = useRoomOptionsData() || {};

  const { isCalendarOpen, isMobileSearchPanelModalOpen } =
    useSearchPanelControls();

  const { setSelectedRoomRef } = useMobileRoomScrollIntoView({
    isCalendarOpen,
    isMobileSearchPanelModalOpen,
    isLoading,
  });

  const cta = onCtaClickOverride || onCtaClick;

  return (
    <RoomListContainer flexDirection="column" width="100%" {...rest}>
      {roomOptions?.map((roomOption, index) => {
        const isSelected =
          !isLoading &&
          selectedRoomOption &&
          selectedRoomOption.roomType.id === roomOption.roomType.id &&
          !!roomOption.matchingOffer;

        return (
          <div
            key={roomOption.roomType.id}
            ref={(ref) => {
              const isSelectedRoom =
                selectedRoomOption?.roomType.id === roomOption?.roomType.id;

              isSelectedRoom && setSelectedRoomRef(ref);
            }}
          >
            <RoomOption
              isSelected={!!isSelected}
              roomOption={roomOption}
              roomIndex={(roomIndexOffset || 0) + index + 1}
              onCtaClick={isPackagePageV3Enabled ? cta : onCtaClick}
              isMainRooms={isMainRooms}
            />
          </div>
        );
      })}
    </RoomListContainer>
  );
};

export default RoomList;
